import React, { useState, useEffect } from 'react'
import { Button, Card } from 'react-daisyui'
import { API } from '../../utils/api'
import { Api } from '../../utils/apiServer'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import { AiOutlineCalendar, AiOutlineShoppingCart, AiOutlineCreditCard, AiOutlineLeft, AiOutlineRight, AiOutlineFileText, AiOutlineCheckCircle, AiOutlineClockCircle, AiOutlineCloseCircle } from "react-icons/ai"
import { Helmet } from 'react-helmet'
import MidT from '../../components/MidT'
import DefaultProduct from "../../assets/default-product.jpg"

function TransactionList() {
    const [page, setPage] = useState(1)
    const [rows] = useState(10)
    const [transaction, setTransaction] = useState([])
    const [lastPage, setLastPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(true)
    const [token, setToken] = useState()

    const navigate = useNavigate()
    
    useEffect(() => {
        Init()
    }, [])

    useEffect(() => {
        if (page !== 1) {
            Init()
        }
    }, [page])

    const Init = async () => {
        setLoading(true)
        const params = {
            access: 'auth',
            url: API.TRANSACTION_LIST.url,
            method: API.TRANSACTION_LIST.type,
            reqBody: {
                page: page,
                rows: rows,
                order_by: "transaction_created_datetime",
                sort_by: "desc"
            }
        }
        try {
            const response = await Api(params)
            if (response.status) {
                setTransaction(response.data.data)
                setPage(response.data.page)
                setLastPage(response.data.last_page)
                setTotal(response.data.total)
            } else {
                toast.error(response.message)
            }
        } catch (error) {
            toast.error('Terjadi kesalahan saat memuat data')
        } finally {
            setLoading(false)
        }
    }
    console.log(transaction)
    const handleResume = async (data) => {
        const params = {
            access: 'auth',
            url: API.TRANSACTION_RESUME.url,
            method: API.TRANSACTION_RESUME.type,
            reqBody: {
                transaction_id: data.transaction_id
            }
        }
        try {
            const response = await Api(params)
            if (response.status) {
                setToken(response.data.token)
                toast.success('Melanjutkan pembayaran...')
            } else {
                toast.error(response.message)
            }
        } catch (error) {
            toast.error('Terjadi kesalahan saat memproses pembayaran')
        }
    }

    const getStatusIcon = (status) => {
        switch (status?.toLowerCase()) {
            case 'approved':
            case 'success':
                return <AiOutlineCheckCircle className="text-green-600" />
            case 'pending':
                return <AiOutlineClockCircle className="text-orange-600" />
            case 'rejected':
            case 'failed':
                return <AiOutlineCloseCircle className="text-red-600" />
            default:
                return <AiOutlineFileText className="text-gray-600" />
        }
    }

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {
            case 'approved':
            case 'success':
                return 'bg-green-500'
            case 'pending':
                return 'bg-orange-500'
            case 'rejected':
            case 'failed':
                return 'bg-red-500'
            default:
                return 'bg-gray-500'
        }
    }

    // Loading skeleton component
    const LoadingSkeleton = () => (
        <div className="animate-pulse space-y-4">
            <div className="bg-gray-200 h-8 rounded w-1/3 mx-auto"></div>
            <div className="space-y-3">
                {[...Array(3)].map((_, i) => (
                    <div key={i} className="bg-gray-200 h-32 rounded-lg"></div>
                ))}
            </div>
        </div>
    )

    const handlePaySuccess = (result) => {
        navigate(`/order/status/success`)
    }

    const handlePayError = (result) => {
        navigate(`/order/status/error`)
    }

    const handlePayPending = (result) => {
        navigate(`/order/status/pending`)
    }

    const handlePayClose = (result) => {
        setToken(null)
        navigate(`/order/status/nopay`)
    }

    if (loading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
                <div className="mx-auto max-w-sm px-5 py-6">
                    <LoadingSkeleton />
                </div>
            </div>
        )
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            <ToastContainer autoClose={1000} />
            <Helmet>
                <script src={process.env.REACT_APP_MIDTRANS_SNAP_SCRIPT} async></script>
            </Helmet>
            <div className="mx-auto max-w-sm px-5 py-6">
                <div className='flex flex-col space-y-6 scrollbar-hide'>

                    {/* Header Section */}
                    <div className="text-center space-y-2">
                        <div className="flex items-center justify-center space-x-2">
                            <AiOutlineCreditCard className="text-2xl text-blue-600" />
                            <h1 className="text-2xl font-bold text-gray-800">Riwayat Transaksi</h1>
                        </div>
                        <p className="text-gray-600 text-sm">Pantau semua transaksi Anda</p>
                        {total > 0 && (
                            <p className="text-sm text-gray-500 bg-gray-100 px-3 py-1 rounded-full">
                                Total {total} transaksi
                            </p>
                        )}
                    </div>

                    {/* Transaction List */}
                    {transaction.length === 0 ? (
                        <Card className="bg-gradient-to-r from-gray-50 to-white border-2 border-dashed border-gray-300">
                            <Card.Body className="text-center py-12">
                                <AiOutlineCreditCard className="text-6xl text-gray-400 mx-auto mb-4" />
                                <p className="text-gray-500 font-medium text-lg">Belum ada transaksi</p>
                                <p className="text-gray-400 text-sm mt-1">Transaksi akan muncul di sini</p>
                            </Card.Body>
                        </Card>
                    ) : (
                        <div className="space-y-4">
                            {transaction.map((t,i)=>(
                                <Card key={i} className="bg-white shadow-lg hover:shadow-xl transition-all duration-300 border-0 overflow-hidden">
                                    <Card.Body className="p-0">
                                        {/* Status Header */}
                                        <div className="bg-gradient-to-r from-blue-50 to-purple-50 px-4 py-3 border-b">
                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center space-x-2">
                                                    <AiOutlineCalendar className="text-gray-600 text-sm" />
                                                    <span className="text-sm font-medium text-gray-700">
                                                        {moment(t.transaction_created_datetime).format('DD MMM YYYY, HH:mm')}
                                                    </span>
                                                </div>
                                                <div className={`flex items-center space-x-1 px-3 py-1 rounded-full text-xs font-semibold text-white ${getStatusColor(t.transaction_approve_status_name)}`}>
                                                    {getStatusIcon(t.transaction_approve_status_name)}
                                                    <span className="capitalize">{t.transaction_approve_status_name}</span>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Transaction Content */}
                                        <div className="p-4 space-y-3">
                                            {/* Transaction Number */}
                                            <div className="flex items-center justify-between">
                                                <span className="text-sm text-gray-600">No. Transaksi</span>
                                                <span className="font-mono text-sm font-medium text-gray-800">
                                                    {t.transaction_number}
                                                </span>
                                            </div>

                                            {/* Product Details */}
                                            <div className="flex space-x-3">
                                                <div className="flex-shrink-0">
                                                    <img
                                                        src={t.transaction_detail?.[0]?.transaction_detail_payload?.item_image?.[0] || DefaultProduct}
                                                        alt="Product"
                                                        className="w-16 h-16 rounded-lg object-cover shadow-sm"
                                                        onError={(e) => {
                                                            e.target.src = DefaultProduct
                                                        }}
                                                    />
                                                </div>
                                                <div className="flex-1 min-w-0">
                                                    <div className="flex items-center space-x-1 mb-1">
                                                        <AiOutlineShoppingCart className="text-gray-500 text-sm" />
                                                        <span className="text-sm font-medium text-gray-800">Produk</span>
                                                    </div>
                                                    <p className="text-sm text-gray-600 leading-tight line-clamp-2">
                                                        {t.transaction_detail?.map((d,o)=>
                                                            o === 0 ? d.transaction_detail_item_name : ` - ${d.transaction_detail_item_name}`
                                                        ).join('')}
                                                    </p>
                                                </div>
                                            </div>

                                            {/* Total Amount */}
                                            <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-3 rounded-lg border border-green-100">
                                                <div className="flex items-center justify-between">
                                                    <span className="text-sm font-medium text-green-800">Total Pembayaran</span>
                                                    <span className="text-lg font-bold text-green-600">
                                                        Rp {Intl.NumberFormat('en-ID').format(t.transaction_total_amount)}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Action Button */}
                                            {t.transaction_approve_status_name?.toLowerCase() === 'pending' && (
                                                <Button
                                                    className="w-full bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white border-none"
                                                    onClick={()=>handleResume(t)}
                                                >
                                                    <AiOutlineCreditCard className="mr-2" />
                                                    Lanjutkan Pembayaran
                                                </Button>
                                            )}
                                        </div>
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                    )}
                    {/* Pagination */}
                    {transaction.length > 0 && (
                        <div className="flex justify-center items-center space-x-4 pt-4">
                            <Button
                                size="sm"
                                variant="outline"
                                disabled={page === 1}
                                onClick={() => setPage(page - 1)}
                                className="border-gray-300"
                            >
                                <AiOutlineLeft className="mr-1" />
                                Previous
                            </Button>

                            <div className="flex items-center space-x-2">
                                <span className="text-sm text-gray-600">Page</span>
                                <span className="bg-blue-500 text-white px-3 py-1 rounded-lg font-semibold">
                                    {page}
                                </span>
                                <span className="text-sm text-gray-600">of {lastPage}</span>
                            </div>

                            <Button
                                size="sm"
                                variant="outline"
                                disabled={page === lastPage}
                                onClick={() => setPage(page + 1)}
                                className="border-gray-300"
                            >
                                Next
                                <AiOutlineRight className="ml-1" />
                            </Button>
                        </div>
                    )}
                </div>
            </div>

            {token && (
                <MidT
                    clientKey={process.env.REACT_APP_CLIENT_KEY_MIDTRANS}
                    token={token}
                    onSuccess={(result)=>handlePaySuccess(result)}
                    onError={(result)=>handlePayError(result)}
                    onPending={(result)=>handlePayPending(result)}
                    onClose={()=>handlePayClose()}
                />
            )}
        </div>
    )
}

export default TransactionList